/**
 * Theme Context
 * The app is locked to light theme; this context exists so consumers
 * of `actualTheme` don't need to change.
 */

import { createContext, useContext, useEffect } from 'react'

interface ThemeContextType {
  actualTheme: 'light'
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined)

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('dark')
    root.classList.add('light')
  }, [])

  return (
    <ThemeContext.Provider value={{ actualTheme: 'light' }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider')
  }
  return context
}
